export default "__VITE_ASSET__Bwf1O6Dr__"